import React from 'react';

import { createOnStripe } from "../../../data/accounts";
import {
    redirect
} from "react-router-dom";

import 'moment/locale/fr';
export async function loader({ params }) {

    const link = await createOnStripe();
    // redirection vers link.url
    return redirect(link.link);

}


export default function StripeDeposit() {
    
    return (
        <div>
           
            
                
        </div>
    )            
}